import React, { Component } from "react";
import { Helmet } from "react-helmet";

export default class ufit extends Component {
  componentDidMount() {
    this._ismounted = true;
    window.slider();
  }

  componentWillUnmount() {
    this._ismounted = false;
  }

  render() {
    return (
      <section id="rumba">
        <Helmet>
          <meta charSet="utf-8" />
          <meta
            name="description"
            content="Rumba - Ballroom Dancing is a step by step guide to the American Style Rumba."
          />
          <title>Rumba - Ballroom Dancing</title>
        </Helmet>
        <a
              href="https://play.google.com/store/apps/details?id=com.doubleserves.rumba"
              target="_blank"
              rel="noopener noreferrer"
            >
        <img src="/images/rumba/Screenshot1.png" alt="Rumba - Ballroom Dancing"  style={{width:"100%"}} /></a>
        <div className="paragraph col-md-12">
          <h1>Rumba - Ballroom Dancing</h1>
          <a
            href="https://play.google.com/store/apps/details?id=com.doubleserves.rumba"
            target="_blank"
            rel="noopener noreferrer"
          >
            Rumba - Ballroom Dancing
          </a>{" "} is a step by step guide to the American Style Rumba. 
          Learn all the steps in the American style rumba through this step by step guide. 
          Practice and master the rumba steps as you play the Name That Step game. 
          You will become an expert before you know it. &#x1F483;
          <br />
        </div>
        
        <div className="paragraph col-md-12">
          <h2 className="heading">FEATURES</h2>
          <table>
              <tr>
                  <td>
                    <ul>
                        <li>Voice guided tour of all 10 steps in the American Style Rumba</li>
                        <li>Covers both male and female steps</li>
                        <li>Repeat a step easily</li>
                        <li>Watch demo videos!</li>
                        <li>Name That Step memory game</li>
                        <li>Comments and suggestions welcome</li>
                    </ul>
                  </td>
                  <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                  <td>
                    <img src="/images/rumba/shoeRight0.png" alt="Women Left Shoe" height="50" width="20" className="rotate180"/>
                    <img src="/images/rumba/shoeLeft0.png" alt="Women Right Shoe" height="50" width="20" className="rotate180"/><br/>
                    <img src="/images/rumba/shoeLeft1.png" alt="Men Left Shoe" height="50" width="20" />
                    <img src="/images/rumba/shoeRight1.png" alt="Men Right Shoe" height="50" width="20"/>
                  </td>
              </tr>
          </table>
        </div>
      </section>
    );
  }
}
